<div class="px-4 b-b pb-2 mb-4" *ngIf="!hideNotificationFlag">
    <div class="row justify-content-between align-v-center">
        <h5 class="medium mb-0">Notification Rule Editor</h5>
        <button class="btn btn-secondary" (click)="cancel()"><i class="fa fa-arrow-left mr-2"></i> Back
        </button>
    </div>
</div>

<div class="card mb-4" *ngIf="!hideNotificationFlag">
    <div class="card-header">Basic details</div>
    <div class="card-body p-3 row">
        <div class="col-4">
            <div class="form-group">
                <label>Name</label>
                <textarea class="form-control" rows="5" [(ngModel)]="notification.name">
                </textarea>
            </div>
        </div>
        <div class="col-4">
            <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" rows="5" [(ngModel)]="notification.description">
                </textarea>
            </div>
        </div>
        <div class="col-4">
            <div class="form-group" *ngIf="notification.notificationChannel == 'Email'">
                <label>Default Subject template</label>
                <textarea class="form-control" rows="5" [(ngModel)]="notification.subjectTemplate">
                    </textarea>
            </div>
        </div>
        <ng-container *ngIf="notification.notificationChannel == 'Email'">
            <div class="col-12">
                <div class="form-group">
                    <label>Default Message template</label>
                    <div class="w-100 float-left rich-text-editor basicEditor.editor.enable(false)">
                        <quill-editor [(ngModel)]='notification.messageTemplate'>
                            <div quill-editor-toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" [title]="'Bold'"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-italic" [title]="italic"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-underline" [title]="'Underline'"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" [title]="'list'" value="ordered">
                                    </button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" [title]="'list'" value="bullet">
                                    </button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" [title]="'list'" value="check">
                                    </button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-header" [title]="'header'" value="1">
                                    </button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-header" [title]="'header'" value="2">
                                    </button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-blockquote" [title]="'blockquote'"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-formula" [title]="'formula'"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-link" [title]="'link'"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-code-block" [title]="'code-block'"></button>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-font" [title]="'font'">
                                        <option value="sans serif"></option>
                                        <option value="serif"></option>
                                        <option value="monospace"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-color" [title]="'color'">
                                        <option value="white"></option>
                                        <option value="black"></option>
                                        <option value="red"></option>
                                        <option value="blue"></option>
                                        <option value="green"></option>
                                        <option value="lightblue"></option>
                                        <option value="orange"></option>
                                        <option value="pink"></option>
                                        <option value="yellow"></option>
                                        <option value="purple"></option>
                                        <option value="grey"></option>
                                        <option value="lightgreen"></option>
                                        <option value="lightyellow"></option>
                                        <option value="magenta"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-background" [title]="'background'">
                                        <option value="white"></option>
                                        <option value="black"></option>
                                        <option value="red"></option>
                                        <option value="blue"></option>
                                        <option value="green"></option>
                                        <option value="lightblue"></option>
                                        <option value="orange"></option>
                                        <option value="pink"></option>
                                        <option value="yellow"></option>
                                        <option value="purple"></option>
                                        <option value="grey"></option>
                                        <option value="lightgreen"></option>
                                        <option value="lightyellow"></option>
                                        <option value="magenta"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-size" [title]="'font'">
                                        <option value="small"></option>
                                        <option value="large"></option>
                                        <option value="huge"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-align" [title]="'Aligment'">
                                        <option selected></option>
                                        <option value="center"></option>
                                        <option value="right"></option>
                                        <option value="justify"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-strike" [title]="'strike'"></button>
                                </span>
                            </div>
                        </quill-editor>
                    </div>


                </div>
            </div>
        </ng-container>
    </div>
</div>

<div class="card mb-4" *ngIf="!hideNotificationFlag">
    <div class="card-header">SETTINGS</div>

    <div class="card-body p-3 row">
        <div class="col-4">
            <div class="form-group">
                <label>Notifation channel</label>
                <select class="form-control" [(ngModel)]="notification.notificationChannel" disabled>
                    <option value="Email">Email</option>
                    <option value="Stream">Stream</option>
                </select>
            </div>
        </div>
        <div class="col-4">
            <div class="form-group">
                <label>Event handling mechanism</label>
                <select class="form-control" [(ngModel)]="notification.eventHandlingMechanism">
                    <option value="sync">Synchronous</option>
                    <option value="async">Asynchronous</option>
                </select>
            </div>
        </div>
        <div class="col-4">
            <div class="form-group">
                <label>Disabled</label>
                <div class="checkbox checkbox-primary">
                    <input id="self" type="checkbox" [(ngModel)]="notification.disabled">
                    <label class="mb-0 float-left mr-2" for="self"></label>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="card mb-4" *ngIf="notification.notificationChannel=='Email'">
    <div class="card-header" *ngIf="!hideNotificationFlag">Notification languages</div>
    <div class="card-body p-3 mb-4" notificationLangGrid (editLangFlag)="hideNotification($event)"
         [notification]="notification"></div>
</div>

<div class="card mb-4" *ngIf="!hideNotificationFlag && notification.notificationChannel=='Email'">
    <div class="card-header">Notification Recipients</div>

    <div class="card-body p-3 mb-4">
        <div class="row justify-content-end pr-3">
            <button class="btn btn-success mb-3" data-target="#demo" data-toggle="collapse" (click)="addNewRecipient()">
                Add
                new
            </button>
        </div>

        <div class="light-bg w-100 float-left p-2 grid-details">
            <div class="col-lg-3 col-md-3 float-left">
                <h6 class="mb-lg-0 medium"> Recipient Type </h6>
            </div>
            <div class="col-lg-3 col-md-3 float-left">
                <h6 class="mb-lg-0 medium"> Recipient </h6>
            </div>
        </div>
        <ng-container *ngIf="notification.notificationRecipients 
        && notification.notificationRecipients.length > 0">
            <div class="w-100 float-left p-2 grid-details collapse"
                 *ngFor="let recipient of notification.notificationRecipients;index as i">
                <div class="col-lg-3 col-md-3 float-left">
                    <select class="form-control" id='{{recipient.id+"_RT"}}' [(ngModel)]="recipient.recipientType">
                        <option value="MANUAL">Manual</option>
                        <option value="VARIABLE">Variable</option>
                    </select>
                </div>
                <div class="col-lg-3 col-md-3 float-left" id='{{recipient.id+"_R"}}'
                     *ngIf="recipient.recipientType=='MANUAL'">
                    <input class="form-control rounded" type="text" [(ngModel)]="recipient.recipient">
                </div>
                <div class="col-lg-3 col-md-3 float-left" id='{{recipient.id+"_R"}}'
                     *ngIf="recipient.recipientType=='VARIABLE'">
                    <select class="form-control" id='{{recipient.id+"_R"}}' [(ngModel)]="recipient.recipient">
                        <option *ngFor="let variable of variables;index as i"
                                value='{{variable.variableName}}'>{{variable.variableName}}
                        </option>
                    </select>
                </div>

            </div>
        </ng-container>
        <ng-container *ngIf="notification.notificationRecipients 
        && notification.notificationRecipients.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                    <img src="./assets/img/load.gif" alt="loading" width="80px">
                </div> -->
                <div class="loader-div">
                    <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>
    </div>
</div>
<div class="px-3 mb-3" *ngIf="!hideNotificationFlag">
    <button class="btn btn-success float-right ml-3" (click)='save()'>Save</button>
    <button class="btn btn-secondary float-right" (click)='cancel()'>Cancel</button>
</div>



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/editNotificationComponent.html